export class ApproveRiskCalculationCommand {
    public comment: string;

    public constructor(init: Partial<ApproveRiskCalculationCommand>) {
        Object.assign(this, init);
    }
}
